import './index.scss'
import React, {useEffect, useRef, useState} from "react";
import {Header, ListView} from "../../../../components";
import Service from "../service";
const SyntheticList = () => {
  const [dataList, setDataList] = useState([])
  const [loading, setLoading] = useState(true)
  const [hasMore, setHasMore] = useState(false)
  const currentPage = React.useRef(1)

  useEffect(()=>{
    onRefresh(true);
  },[])
  //加载列表数据
  const onRefresh = async (loading=false) => {
    currentPage.current = 1;
    if(loading) {
      setLoading(true)
    }
    const res = await Service.getCompoundList(
      {
        pageNum: currentPage.current,
        pageSize: 10,
      },
      loading
    );
    if(loading) {
      setLoading(false)
    }
    if (res?.data) {
      const { count = 0, list = [] } = res.data;
      setDataList(list);
      setHasMore(count > list?.length);
    }
  }
  const loadMore = async () => {
    const res = await Service.getCompoundList(
      {
        pageNum: currentPage.current+1,
        pageSize: 10,
      },
      loading
    );
    if (res?.data) {
      const { count = 0,list = []} = res.data;
      setDataList([...dataList, ...list]);
      setHasMore(count > [...dataList, ...list]?.length)
      // currentPage.current = currentPage.current + 1;
    }
  }

  const renderItem = (item) => {
    return (
      <div className="syntheticListContainer">
        <div className="syntheticListTopBox">
          <div className="imgBox">
            <img src={item?.imgUrl || require('../imgs/power.png')} alt=""/>
          </div>
          <div className="syntheticListRightBox">
            <div className="powerTitle">{item?.resName}</div>
            <div className="syntheticListCount">x{item?.mergeCount}</div>
          </div>
        </div>
        <div className="syntheticListInfoBox">
          <div>合成时间：{item?.mergeTime}</div>
        </div>
      </div>
    )
  }
  return (
    <div className="syntheticListPage">
      <div>
        <Header midText="合成记录" bgColor={'#FFFFFF'}/>
      </div>
      <div className="body-container">
        <ListView
          dataSource={dataList}
          renderItem={renderItem}
          hasMore={hasMore}
          emtyDesc={loading ? '数据加载中...':'暂无数据'}
          onRefresh={onRefresh}
          loadMore={loadMore}
        />
      </div>
    </div>
  )
}
export default SyntheticList